import * as css from "./Mission.module.scss";

export function Mission({scrollRef}) {
    const enkindleWorshipURL = new URL("../../images/enkindle-worship.svg", import.meta.url);
    
    return (
        <div ref={scrollRef} className={css.missionBox}>
            <div className={css.mission}>
                <div className={css.missionPhotoBox}>
                    <img src={enkindleWorshipURL} alt="Enkindle Worship - building relationship with Jesus through devotional music, the Eucharist, and giving the Kerygma." />
                </div>
                <div className={css.missionMessageBox}>
                    <h2 className={`center heading ${css.missionHeading}`}>The Mission</h2>
                    <p className={`center ${css.missionContent}`}>Enkindle's mission is to help individuals build relationship with Jesus through heart-engaging devotional music, Eucharistic exposure, and connection with Christianity's foundational story of the Kerygma.</p>
                </div>
            </div>
        </div>
    );
} 